<template>
    <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#">الأخبار </a> </li>
        </template>
    </Path>

    <section>
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 ">

                        <h1 class="blueFont py-3"> تشغيل (السجل المدنى الذكى) </h1>

                        <p>
                            تنفيذا لتوجيهات السيد الفاضل اللواء وزير الداخليه وموافقه سيادته على تنفيذ خطه تطوير اداء
                            القطاع والارتقاء بالخدمات المقدمه لجمهور المواطنين والتيسير عليهم لمواجهه التحديات والمعوقات
                            التى تؤثر على منظومه العمل بقطاع الاحوال المدنية وبناء على توجيهات السيد اللواء مساعد الوزير
                            لقطاع الاحوال المدنية تم تنفيذ الاتى :
                            <br> تشغيل (السجل المدنى الذكى) من خلال (10) ماكينات (مرحلة أولى) بـ (القطاع بالعباسية
                            –المركز النموذجى بالعباسية- مطار القاهرة الجوى– مول "سيتى ستارز/ سنتر ألماظة/ مكسيم التجمع"
                            بالقاهرة – مول العرب بـ6 أكتوبر- مول مصر بـ6 أكتوبر - سيتى سنتر المعادى كارفور – ادارة
                            الجيزة) لإستخراج المُصدرات المُميكنه (شهادات "ميلاد/وفاة/زواج/طلاق") ومُزوده بالتحقق من
                            الهوية من خلال مطابقة بصمة أحد أصبع المواطن وماهو مُسجل بقاعدة بيانات الرقم القومى
                            البايومترية وتخزين صورة وبصمة المواطن لإسترجاعها حال طلبها وخاصية السداد النقدى .
                        </p>


                        <img src="@/assets/images/smartrecord.jpg" alt="" class="img-fluid py-3">
                    </div>

                </div>
            </div>
        </div>
    </section>

</template>

<script>
import Path from '@/components/Path.vue'
export default {
    name: 'News1Comp',
    components: { Path },
    created() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },
}


</script>